<div class="container-fluid">
  <div class="styles-body">
    <div class="panel-body content-body-pages">
      <div class="page-header">
        <div class="header-content">
          <div class="header-icon">
            <mat-icon>payment</mat-icon>
          </div>
          <div class="header-text">
            <h1 class="page-title">{{ 'PaymentMethods' | translate }}</h1>
            <p>{{ 'ManagePaymentMethods' | translate }}</p>
          </div>
        </div>
      </div>
      <div class="payment-methods-management-container">
        <div class="left-section">
          <div class="payment-methods-section">
            <div class="section-title">
              <span>{{ 'PaymentMethods' | translate }}</span>
            </div>

            @if (isLoadingPaymentMethods) {
              <div class="loading-payment-methods">
                <div class="loading-spinner">
                  <mat-icon>refresh</mat-icon>
                </div>
                <p>{{ 'LoadingPaymentMethods' | translate }}</p>
              </div>
            } @else {
              <div class="payment-methods-grid">
                <div (click)="onCreatePaymentMethodClicked()"
                     [ngClass]="{'selected': !selectedPaymentMethod}"
                     class="payment-method-item add-payment-method-item">
                  <div class="payment-method-icon">
                    <mat-icon>add</mat-icon>
                  </div>
                  <div class="payment-method-title">{{ 'AddPaymentMethod' | translate }}</div>
                </div>

                @for (paymentMethod of paymentMethods; track paymentMethod.PaymentMethodId) {
                  <div
                    [ngClass]="{'selected': selectedPaymentMethod?.PaymentMethodId === paymentMethod.PaymentMethodId}"
                    class="payment-method-item">
                    <div (click)="onPaymentMethodClick(paymentMethod)"
                         class="payment-method-content">
                      <div class="payment-method-icon">
                        @if (paymentMethod.Icon) {
                          <img [src]="formatImage('', paymentMethod?.Icon)"
                               alt="payment method"
                               height="40"
                               width="40">
                        } @else {
                          <mat-icon>payment</mat-icon>
                        }
                      </div>
                      <div class="payment-method-info">
                        <div class="payment-method-title">{{ paymentMethod.Title }}</div>
                        <div class="payment-method-type">{{ getPaymentMethodTypeTitle(paymentMethod.Type) }}</div>
                        <div class="payment-method-status">
                          @if (paymentMethod.IsActive) {
                            <span class="status-active">{{ 'Active' | translate }}</span>
                          } @else {
                            <span class="status-inactive">{{ 'Inactive' | translate }}</span>
                          }
                        </div>
                      </div>
                    </div>
                    <div class="payment-method-actions">
                      <button (click)="onUpdatePaymentMethodClicked(paymentMethod); $event.stopPropagation()"
                              class="action-btn edit-btn">
                        <mat-icon>edit</mat-icon>
                      </button>
                      <button (click)="onDeletePaymentMethodClicked(paymentMethod); $event.stopPropagation()"
                              class="action-btn delete-btn">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
        <div class="right-section">
          <div class="payment-method-details-section">
            <div class="section-title">
              <span>{{ getSelectedPaymentMethodTitle() }}</span>
            </div>

            @if (selectedPaymentMethod || !isEditing) {
              <div class="payment-method-form">
                <form #paymentMethodForm="ngForm"
                      (ngSubmit)="onSubmitPaymentMethod()">
                  <!-- Basic Information -->
                  <div class="form-section">
                    <h4>{{ 'BasicInformation' | translate }}</h4>
                    <div class="form-row">
                      <div class="form-group">
                        <app-frontend-input
                          [(value)]="editingPaymentMethod.Title"
                          [required]="true"
                          [title]="'Title'"
                          [type]="'text'">
                        </app-frontend-input>
                      </div>
                      <div class="form-group">
                        <app-frontend-dropdown
                          (onSelected)="onTypeSelect($event)"
                          [displayKey]="'Title'"
                          [fieldName]="'Value'"
                          [isSearchable]="false"
                          [options]="typeOptions"
                          [required]="true"
                          [selectedOptions]="selectedType ? [selectedType] : []"
                          [title]="'Type'">
                        </app-frontend-dropdown>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group">
                        <app-frontend-select [(value)]="branchIds"
                                             [controller]="'businesses'"
                                             [displayKey]="'Title'"
                                             [fieldName]="'BusinessId'"
                                             [isMultiple]="true"
                                             [method]="'getBranches'"
                                             [microservice]="Constant.getFoodShop()"
                                             [protocolMethod]="'POST'"
                                             [required]="false"
                                             [searchOnKey]="'Title'"
                                             [selectedOptions]="selectedBranches"
                                             [title]="'ProviderBranches'"
                                             [version]="'v1'"></app-frontend-select>
                        <span
                          style="color: red">*در صورت انتخاب نکردن شعبه برای تمامی شعبه ها در نظر گرفته می شود</span>
                      </div>
                      <div class="form-group">
                        <app-frontend-check-box
                          [(value)]="editingPaymentMethod.IsActive"
                          [title]="'IsActive'">
                        </app-frontend-check-box>
                      </div>
                    </div>
                  </div>
                  <!-- PSP Configuration -->
                  @if (editingPaymentMethod.Type === 'PSP') {
                    <div class="form-section">
                      <h4>{{ 'PSPConfiguration' | translate }}</h4>
                      <div class="form-row">
                        <div class="form-group">
                          <app-frontend-dropdown
                            (onSelected)="onPSPProviderSelect($event)"
                            [displayKey]="'Title'"
                            [fieldName]="'Value'"
                            [isSearchable]="false"
                            [options]="pspProviderOptions"
                            [required]="true"
                            [selectedOptions]="selectedPSPProvider ? [selectedPSPProvider] : []"
                            [title]="'PSPProvider'">
                          </app-frontend-dropdown>
                        </div>
                      </div>

                      @if (pspProvider === 'SAMAN') {
                        <div class="form-row">
                          <div class="form-group">
                            <app-frontend-input
                              [(value)]="samanTerminalId"
                              [required]="true"
                              [title]="'TerminalId'"
                              [type]="'text'">
                            </app-frontend-input>
                          </div>
                          <div class="form-group">
                            <app-frontend-file-chooser
                              [(files)]="pspIconFiles"
                              [accept]="'image/*'"
                              [isMultiple]="false"
                              [title]="'PSPIcon'">
                            </app-frontend-file-chooser>
                          </div>
                        </div>
                      }
                      @if (pspProvider === 'ZARINPAL') {
                        <div class="form-row">
                          <div class="form-group">
                            <app-frontend-input
                              [(value)]="zarinpalMerchantId"
                              [required]="true"
                              [title]="'MerchantId'"
                              [type]="'text'">
                            </app-frontend-input>
                          </div>
                          <div class="form-group">
                            <app-frontend-file-chooser
                              [(files)]="pspIconFiles"
                              [accept]="'image/*'"
                              [isMultiple]="false"
                              [title]="'PSPIcon'">
                            </app-frontend-file-chooser>
                          </div>
                        </div>
                      }
                      @if (pspProvider === 'MELAT') {
                        <div class="form-row">
                          <div class="form-group">
                            <app-frontend-input
                              [(value)]="melatTerminalId"
                              [required]="true"
                              [title]="'TerminalId'"
                              [type]="'text'">
                            </app-frontend-input>
                          </div>
                          <div class="form-group">
                            <app-frontend-file-chooser
                              [(files)]="pspIconFiles"
                              [accept]="'image/*'"
                              [isMultiple]="false"
                              [title]="'PSPIcon'">
                            </app-frontend-file-chooser>
                          </div>
                          <div class="form-group">
                            <app-frontend-input
                              [(value)]="melatUsername"
                              [required]="true"
                              [title]="'UserName'"
                              [type]="'text'">
                            </app-frontend-input>
                          </div>
                          <div class="form-group">
                            <app-frontend-input
                              [(value)]="melatPassword"
                              [required]="true"
                              [title]="'PassWord'"
                              [type]="'text'">
                            </app-frontend-input>
                          </div>
                        </div>
                      }
                    </div>
                  }

                  <!-- Cash Configuration -->
                  @if (editingPaymentMethod.Type === 'CASH') {
                    <div class="form-section">
                      <h4>{{ 'CashConfiguration' | translate }}</h4>
                      <div class="form-row">
                        <div class="form-group full-width">
                          <app-frontend-map [(latitudePointer)]="editingPaymentMethod.Latitude"
                                            [(longitudePointer)]="editingPaymentMethod.Longitude"
                                            [height]="'400px'"
                                            [isRadiusSelectionEnable]="true"
                                            [radius]="editingPaymentMethod.Radius"
                                            [width]="'100%'"></app-frontend-map>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="form-group">
                          <app-frontend-input
                            [(value)]="editingPaymentMethod.Radius"
                            [required]="true"
                            [title]="'Radius'"
                            [type]="'number'">
                          </app-frontend-input>
                        </div>
                      </div>
                    </div>
                  }

                  <!-- Wallet Configuration -->
                  @if (editingPaymentMethod.Type === 'WALLET') {
                    <div class="form-section">
                      <h4>{{ 'WalletConfiguration' | translate }}</h4>
                      <div class="form-row">
                        <div class="form-group">
                          <app-frontend-input
                            [(value)]="editingPaymentMethod.WalletAddress"
                            [required]="true"
                            [title]="'WalletAddress'"
                            [type]="'text'">
                          </app-frontend-input>
                        </div>
                      </div>
                    </div>
                  }

                  <!-- POS Configuration -->
                  @if (editingPaymentMethod.Type === 'POS') {
                    <div class="form-section">
                      <h4>{{ 'POSConfiguration' | translate }}</h4>
                      <!-- Poses List -->
                      <div class="poses-list">
                        <div class="poses-header">
                          <span>{{ 'Poses' | translate }} ({{ poses.length }})</span>
                        </div>
                        <div (cdkDropListDropped)="onPosDrop($any($event))"
                             cdkDropList
                             class="poses-grid">
                          <!-- Add POS Button -->
                          <div (click)="onAddPos()"
                               class="pos-card-item add-pos-item">
                            <div class="pos-card add-pos">
                              <div class="add-pos-content">
                                <mat-icon>add</mat-icon>
                                <span>{{ 'AddPOS' | translate }}</span>
                              </div>
                            </div>
                          </div>
                          <!-- Existing Poses -->
                          @for (pos of poses; track $index) {
                            <div [ngClass]="{'editing': selectedPosIndex === $index}"
                                 cdkDrag
                                 class="pos-card-item">
                              <!-- Display Mode -->
                              @if (selectedPosIndex !== $index) {
                                <div (click)="onEditPos(pos, $index)"
                                     class="pos-card">
                                  <div class="pos-card__header">
                                    <span class="pos-card__icon">
                                      <svg fill="none"
                                           viewBox="0 0 40 40"
                                           xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="20"
                                                cy="20"
                                                fill="#10b981"
                                                r="18"/>
                                        <path
                                          d="M12 22V18C12 17.4477 12.4477 17 13 17H27C27.5523 17 28 17.4477 28 18V22"
                                          stroke="#fff"
                                          stroke-linecap="round"
                                          stroke-width="2.2"/>
                                        <rect fill="#fff"
                                              height="4"
                                              rx="1.5"
                                              width="11"
                                              x="14.5"
                                              y="22.5"/>
                                        <circle cx="17.5"
                                                cy="24.5"
                                                fill="#10b981"
                                                r="0.9"/>
                                        <circle cx="22.5"
                                                cy="24.5"
                                                fill="#10b981"
                                                r="0.9"/>
                                      </svg>
                                    </span>
                                    <span class="pos-card__bank-name">{{ pos.BankName }}</span>
                                  </div>
                                  <div class="pos-card__number">
                                    {{ pos.TerminalIp }}
                                  </div>
                                  <div class="pos-card__footer">
                                    <span class="pos-card__holder">{{ pos.BankName }}</span>
                                    <span class="pos-card__amount">پورت: {{ pos.TerminalPort }}</span>
                                  </div>
                                  <div class="pos-card__actions pos-card__actions--left">
                                    <button (click)="onDeletePos($index); $event.stopPropagation()"
                                            [title]="'Delete' | translate"
                                            class="delete-btn"
                                            type="button">
                                      <mat-icon>delete</mat-icon>
                                    </button>
                                  </div>
                                </div>
                              }

                              <!-- Edit Mode -->
                              @if (selectedPosIndex === $index) {
                                <div class="pos-card edit-mode">
                                  <div class="pos-edit-form">
                                    <h5>{{ 'EditPOS' | translate }}</h5>
                                    <div class="form-row">
                                      <div class="form-group">
                                        <app-frontend-input
                                          [(value)]="editingPos.BankName"
                                          [required]="true"
                                          [title]="'BankName'"
                                          [type]="'text'">
                                        </app-frontend-input>
                                      </div>
                                    </div>
                                    <div class="form-row">
                                      <div class="form-group">
                                        <app-frontend-input
                                          [(value)]="editingPos.TerminalIp"
                                          [required]="true"
                                          [title]="'TerminalIp'"
                                          [type]="'text'">
                                        </app-frontend-input>
                                      </div>
                                      <div class="form-group">
                                        <app-frontend-input
                                          [(value)]="editingPos.TerminalPort"
                                          [required]="true"
                                          [title]="'TerminalPort'"
                                          [type]="'number'">
                                        </app-frontend-input>
                                      </div>
                                    </div>
                                    <div class="pos-form-actions">
                                      <app-frontend-button
                                        (click)="onSavePos()"
                                        [Image]="true"
                                        [class]="'card-green'"
                                        [disabled]="false"
                                        [src]="'icons/tick-square.svg'"
                                        [title]="'Save'">
                                      </app-frontend-button>
                                      <app-frontend-button
                                        (click)="onCancelPosEdit()"
                                        [Image]="true"
                                        [class]="'card-yellow'"
                                        [disabled]="false"
                                        [src]="'icons/close-square.svg'"
                                        [title]="'Cancel'">
                                      </app-frontend-button>
                                    </div>
                                  </div>
                                </div>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  }

                  <!-- Card to Card Configuration -->
                  @if (editingPaymentMethod.Type === 'CARD_TO_CARD') {
                    <div class="form-section">
                      <h4>{{ 'CardToCardConfiguration' | translate }}</h4>
                      <!-- Cards List -->
                      <div class="cards-list">
                        <div class="cards-header">
                          <span>{{ 'Cards' | translate }} ({{ cards.length }})</span>
                        </div>
                        <div (cdkDropListDropped)="onCardDrop($any($event))"
                             cdkDropList
                             class="cards-grid">
                          <!-- Add Card Button -->
                          <div (click)="onAddCard()"
                               class="bank-card-item add-card-item">
                            <div class="bank-card add-card">
                              <div class="add-card-content">
                                <mat-icon>add</mat-icon>
                                <span>{{ 'AddCard' | translate }}</span>
                              </div>
                            </div>
                          </div>
                          <!-- Existing Cards -->
                          @for (card of cards; track $index) {
                            <div [ngClass]="{'editing': selectedCardIndex === $index}"
                                 cdkDrag
                                 class="bank-card-item">
                              <!-- Display Mode -->
                              @if (selectedCardIndex !== $index) {
                                <div (click)="onEditCard(card, $index)"
                                     class="bank-card">
                                  <div class="bank-card__header">
                                    <span class="bank-card__icon">
                                      <svg fill="none"
                                           viewBox="0 0 40 40"
                                           xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="20"
                                                cy="20"
                                                fill="#3a8dde"
                                                r="18"/>
                                        <path
                                          d="M12 22V18C12 17.4477 12.4477 17 13 17H27C27.5523 17 28 17.4477 28 18V22"
                                          stroke="#fff"
                                          stroke-linecap="round"
                                          stroke-width="2.2"/>
                                        <rect fill="#fff"
                                              height="4"
                                              rx="1.5"
                                              width="11"
                                              x="14.5"
                                              y="22.5"/>
                                        <circle cx="17.5"
                                                cy="24.5"
                                                fill="#3a8dde"
                                                r="0.9"/>
                                        <circle cx="22.5"
                                                cy="24.5"
                                                fill="#3a8dde"
                                                r="0.9"/>
                                      </svg>
                                    </span>
                                    <span class="bank-card__bank-name">{{ card.BankName }}</span>
                                  </div>
                                  <div class="bank-card__number">
                                    {{ card.CardNumber | spaceString:4 }}
                                  </div>
                                  <div class="bank-card__footer">
                                    <span class="bank-card__holder">{{ card.CardholderName }}</span>
                                    <span class="bank-card__amount">{{ card.MaximumAmount | number }} ریال</span>
                                  </div>
                                </div>
                                <div class="card-actions card-actions--left">
                                  <button (click)="onDeleteCard($index); $event.stopPropagation()"
                                          class="action-btn delete-btn"
                                          type="button">
                                    <mat-icon>delete</mat-icon>
                                  </button>
                                </div>
                              }

                              <!-- Edit Mode -->
                              @if (selectedCardIndex === $index) {
                                <div class="bank-card edit-mode">
                                  <div class="card-edit-form">
                                    <div class="form-row">
                                      <app-frontend-input
                                        [(value)]="editingCard.BankName"
                                        [required]="true"
                                        [title]="'BankName'"
                                        [type]="'text'">
                                      </app-frontend-input>
                                    </div>
                                    <div class="form-row">
                                      <app-frontend-input
                                        [(value)]="editingCard.CardNumber"
                                        [required]="true"
                                        [title]="'CardNumber'"
                                        [type]="'text'">
                                      </app-frontend-input>
                                    </div>
                                    <div class="form-row">
                                      <app-frontend-input
                                        [(value)]="editingCard.CardholderName"
                                        [required]="true"
                                        [title]="'CardholderName'"
                                        [type]="'text'">
                                      </app-frontend-input>
                                    </div>
                                    <div class="form-row">
                                      <app-frontend-input
                                        [(value)]="editingCard.PaymentPercentage"
                                        [required]="true"
                                        [title]="'PaymentPercentage'"
                                        [type]="'number'">
                                      </app-frontend-input>
                                    </div>
                                    <div class="form-row">
                                      <app-frontend-input
                                        [(value)]="editingCard.MaximumAmount"
                                        [required]="true"
                                        [title]="'MaximumAmount'"
                                        [type]="'number'">
                                      </app-frontend-input>
                                    </div>
                                    <div class="form-row">
                                      <app-frontend-check-box
                                        [(value)]="editingCard.DefaultCard"
                                        [title]="'DefaultCard'">
                                      </app-frontend-check-box>
                                    </div>
                                    <div class="card-form-actions">
                                      <app-frontend-button
                                        (click)="onSaveCard()"
                                        [Image]="true"
                                        [class]="'card-green'"
                                        [src]="'icons/tick-square.svg'"
                                        [title]="'Save'">
                                      </app-frontend-button>
                                      <app-frontend-button
                                        (click)="onCancelCardEdit()"
                                        [Image]="true"
                                        [class]="'card-yellow'"
                                        [src]="'icons/close-square.svg'"
                                        [title]="'Cancel'">
                                      </app-frontend-button>
                                    </div>
                                  </div>
                                </div>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  }


                  <!-- Form Actions -->
                  <div class="form-actions">
                    <app-frontend-button
                      (onSubmit)="onSubmitPaymentMethod()"
                      [Image]="true"
                      [class]="'card-green'"
                      [disabled]="!paymentMethodForm.valid || isSubmitting"
                      [src]="'icons/tick-square.svg'"
                      [title]="isEditing ? 'Update' : 'Create'"
                      [validationRequired]="true">
                    </app-frontend-button>
                    <app-frontend-button
                      (click)="onCancelEdit()"
                      [Image]="true"
                      [class]="'card-yellow'"
                      [disabled]="false"
                      [src]="'icons/close-square.svg'"
                      [title]="'Cancel'">
                    </app-frontend-button>
                  </div>
                </form>
              </div>
            } @else {
              <div class="no-payment-method-selected">
                <div class="no-payment-method-icon">
                  <mat-icon>payment</mat-icon>
                </div>
                <div class="no-payment-method-content">
                  <h4>{{ 'SelectPaymentMethod' | translate }}</h4>
                  <p>{{ 'SelectPaymentMethodToViewDetails' | translate }}</p>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
